<template>
  <div class="brokers-landing-page">
    <div data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500">
      <div class="top-banner">
        <div class="section-tabs">
          <a @click="$router.push({ name: 'AdvisorSideExpertLanding' })" class="label">Advisors</a>
          <a class="label" :style="[
            $route.name == 'BrokerSideExpertLandingpage'
              ? {
                borderColor: ' #1b1b6a',
                color: '#ffffff',
                pointerEvents: 'none',
                background: '#1b1b6a',
              }
              : 'pointer',
          ]">
            Brokers
          </a>
        </div>

        <!-- <div class="main-heading">
        <h1>Business Enterprises solution</h1>
      </div> -->
        <div class="sub-section">
          <el-row>
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2"> &nbsp;</el-col>
            <el-col :xs="20" :sm="20" :md="15" :lg="12" :xl="12">
              <div class="main-heading">
                <h1>Business Enterprises solution</h1>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="2" :md="2" :lg="2" :xl="2"> &nbsp;</el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <div class="left-side">
                <div class="small-txt">More</div>
                <div class="broker-content">
                  <div class="content__container">
                    <!-- <p class="content__container__text">Hello</p> -->

                    <ul class="content__container__list">
                      <li class="content__container__list__item">Visibility</li>
                      <li class="content__container__list__item">Growth</li>
                      <li class="content__container__list__item">Business</li>
                    </ul>
                  </div>
                </div>
                <!-- <div class="second-txt">Growth</div> -->
                <p class="para">
                  We integrate intelligent proprietary algorithms to these price
                  estimates to deliver performance analysis, provide verified
                  trade knowledge with logic aggregation that captures the
                  market sentiment with a community experience that assists
                  retail investors in making informed trade choices
                </p>

                <div class="book-demo">
                  <el-select v-model="checkList" class="m-2" placeholder="Select" size="large" multiple>
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                  <br />
                  <br />
                  <br />
                  <a href="#bookDemo">Book Demo</a>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="13" :lg="13" :xl="13">
              <div class="img-section">
                <img src="../../assets/images/ExpertLandingPage/Web/Brokers/banner image.png" width="100%" alt="" />
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="card-section-desk">
          <div class="top-cards">
            <a class="cards purple" href="#stockantsCommunity" @click="activeSection = 'stockantsCommunity'">
              <el-card>
                <div>Stockants community</div>
              </el-card>
            </a>
            <a class="cards blue" href="#partnerWithUs" @click="activeSection = 'partnerWithUs'">
              <el-card>
                <div>Partner with StockAnts</div>
              </el-card>
            </a>
            <a class="cards orange" href="#stockantsManager" @click="activeSection = 'stockantsManager'">
              <el-card>
                <div>StockAnts Manager</div>
              </el-card>
            </a>
          </div>
        </div>
      </div>

      <div class="card-section-mob">
        <div class="menu">
          <a href="#stockantsCommunity" class="spcl-menu" style="color: #472878">StockAnts community</a>
          <a href="#partnerWithUs" class="spcl-menu" style="color: #15a3b6">Partner with StockAnts</a>
          <a href="#stockantsManager" class="spcl-menu" style="color: #da8016">StockAnts Manager</a>
        </div>
      </div>

      <div class="section2" id="stockantsCommunity">
        <div class="card1">
          <el-card>
            <div class="card2">
              <el-card>
                <el-row>
                  <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                    &nbsp;</el-col>
                  <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
                    <div class="community-top-section">
                      <h1>StockAnts community</h1>

                      <p>
                        StockAnts is a market place for price estimates. We
                        aggregate crowdsourced price estimate that captures the
                        market sentiment and helps retail Investors to make the
                        right Investment decision and trade with broker.
                      </p>
                      <div data-aos="flip-right" data-aos-duration="1000" data-aos-delay="500">
                        <img src="../../assets/images/ExpertLandingPage/Web/Brokers/stockants community.png" alt="" />
                      </div>
                    </div>

                    <div class="community-bottom-section">
                      <div class="bottom-inner left">
                        <p class="top-label">StockAnts community</p>
                        <h2>Microsite Services</h2>
                        <p class="normal-txt">
                          We provide the entire StockAnts Community as a
                          microsite to support your retail user for making
                          investment decision. With StockAnts seamless UI and a
                          subdomain that can be placed on the brokers website,
                          enable retail users to trade with you.
                        </p>
                        <!-- <p class="top-label">For more details</p> -->
                        <a :href="MicrositeService" target="_blank" attributes-list download>
                          <el-button class="blank-yellow">
                            More Details
                          </el-button>
                        </a>
                      </div>
                      <div class="bottom-inner right">
                        <p class="top-label">StockAnts community</p>
                        <h2>Developer Api Support</h2>
                        <p class="normal-txt">
                          StockAnts also provide API solution where the broker
                          can build its own UI and connect StockAnts API to
                          create a same community experience for their user
                          base.
                        </p>
                        <!-- <p class="top-label">For more details</p> -->
                        <a :href="developerApiPdf" target="_blank" attributes-list download>
                          <el-button class="blank-yellow">
                            More Details
                          </el-button>
                        </a>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </el-card>
        </div>
      </div>

      <div class="section2" id="partnerWithUs">
        <div class="card1">
          <el-card>
            <div class="card2">
              <el-card>
                <el-row>
                  <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                    &nbsp;</el-col>
                  <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
                    <div class="community-top-section">
                      <h1>partner with StockAnts</h1>

                      <p>
                      </p>
                      <div data-aos="flip-right" data-aos-duration="1000" data-aos-delay="500">
                        <img src="../../assets/images/ExpertLandingPage/Web/Brokers/partner with us.png" alt="" />
                      </div>
                    </div>

                    <div class="community-bottom-section">
                      <div class="bottom-inner left">
                        <p class="top-label">StockAnts manager</p>
                        <h2>Research partner</h2>
                        <p class="normal-txt">
                          Onboard StockAnts as Research Partner by contributing
                          your research, prove your expertise and get organic
                          visibility.
                        </p>
                        <!-- <p class="top-label">For more details</p> -->
                        <a :href="ResearchPartner" target="_blank" attributes-list download>
                          <el-button class="blank-yellow">
                            More Details
                          </el-button>
                        </a>

                      </div>
                      <div class="bottom-inner right">
                        <p class="top-label">StockAnts manager</p>
                        <h2>trading partner</h2>
                        <p class="normal-txt">
                          StockAnts supports retail users with login through
                          broker, check StockAnts community data and trade with
                          the broker. The broker can become a trading partner
                          with StockAnts by integrating their trading API
                        </p>
                        <!-- <p class="top-label">For more details</p> -->
                        <a :href="TradingPartner" target="_blank" attributes-list download>
                          <el-button class="blank-yellow">
                            More Details
                          </el-button>
                        </a>
                      </div>
                      <!-- </div> -->
                    </div>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </el-card>
        </div>
      </div>

      <div class="sec-5">
        <div class="tracking-outer">
          <p class="head">Tracking Price Estimates</p>

          <div class="tracking-bar">
            <div id="tracking-container" class="marquee">
              <img src="../../assets/images/RetailSideLandingPurple/tracking-removebg-preview (1).png" alt="" />
              <img src="../../assets/images/RetailSideLandingPurple/tracking-removebg-preview (2).png" alt="" />
              <img src="../../assets/images/RetailSideLandingPurple/tracking-removebg-preview (3).png" alt="" />
              <img src="../../assets/images/RetailSideLandingPurple/tracking-removebg-preview (4).png" alt="" />
              <img src="../../assets/images/RetailSideLandingPurple/sharekhan_owler.png" alt="" />
              <img src="../../assets/images/RetailSideLandingPurple/nirmal.jpeg" alt="" />
              <img src="../../assets/images/RetailSideLandingPurple/Kotak-Securities-Logo.jpg" alt="" />
              <img src="../../assets/images/RetailSideLandingPurple/motilal.png" alt="" />
              <img src="../../assets/images/RetailSideLandingPurple/edelweiss.png" alt="" />
              <img src="../../assets/images/RetailSideLandingPurple/prabhudas.png" alt="" />
              <img src="../../assets/images/RetailSideLandingPurple/jainam.png" alt="" />
            </div>
          </div>
        </div>

        <div class="tracking-outer">
          <p class="head">Partners</p>
          <div class="treding-bar">
            <div id="trading-container" class="marquee2">

              <img src="../../assets/images/logo/bigulLgLogo.svg" alt="" />
              <img src="../../assets/images/logo/Nirman-Logo-new.jpg" style="width: 120px; height: 55px;" alt="" />
              <img src="../../assets/images/logo/navia Logo.png" alt="" />
              <img src="../../assets/images/logo/basanLogoLG.png" alt="" />
              <img src="../../assets/images/logo/Paytm_Money_Logo.png" alt="" />
              <img src="../../assets/images/logo/choiceLogo.png" alt="" />
              <img src="../../assets/images/logo/NuvamaLogo.jpeg" alt="" />
              <img src="../../assets/images/logo/alicebluelogo.png" alt="" />
              <img src="../../assets/images/logo/Maitra logo.png" alt="" />
              <img src="../../assets/images/logo/rmoney logo.png" alt="" />
              <img src="../../assets/images/logo/DhanLogo.png" alt="" />
              <img src="../../assets/images/logo/5paisa.jpeg" alt="" />
              <img src="../../assets/images/logo/AngelOne.png" style="width: 200px; height: 70px;" alt="" />
              <img src="../../assets/images/logo/fyers.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="section3" id="stockantsManager">
        <div class="card1">
          <el-card>
            <div class="card2">
              <el-card>
                <el-row>
                  <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                    &nbsp;</el-col>
                  <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
                    <div class="community-top-section">
                      <h1 class="head">StockAnts manager</h1>

                      <p>
                        StockAnts supports with a B2B software on cloud where
                        your research team hard work can be internally tracked,
                        benchmarked and compared on real time basis.
                      </p>
                      <div data-aos="flip-up" data-aos-duration="1000" data-aos-delay="500">
                        <img src="../../assets/images/ExpertLandingPage/Web/Brokers/stockantsmanager.jpeg" alt="" />
                      </div>
                    </div>

                    <div class="community-bottom-section">
                      <div class="bottom-inner">
                        <a href="#bookDemo">
                          <el-button class="blank-yellow">
                            More Details
                          </el-button>
                        </a>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </el-card>
        </div>
      </div>

      <div class="section4" id="bookDemo">
        <el-card>
          <div v-loading="isLoading">
            <h1>Book a demo</h1>

            <div class="label">Name<span style="color: red">*</span></div>
            <div class="input-group-section">
              <div class="form-group" :class="{
                'not-empty': name.length,
                'form-group--error': show_error_on_empty && $v.name.$error,
              }">
                <el-input v-model="name" size="small" type="text" class="form-control" placeholder="Name" name="Name"
                  @input="setName($event)"></el-input>
              </div>
              <div class="error" v-if="show_error_on_empty && !$v.name.required">
                Field is required
              </div>
            </div>

            <div class="label">Email <span style="color: red">*</span></div>
            <div class="input-group-section">
              <div class="form-group" :class="{
                'not-empty': email.length,
                'form-group--error': show_error_on_empty && $v.email.$error,
              }">
                <el-input type="email" v-model="email" size="small" class="form-control" placeholder="Email" name="email"
                  @input="setEmail($event)"></el-input>
              </div>
              <div class="error-text" v-if="is_valid_email_error">
                Use valid email address
              </div>
              <div class="error" v-if="show_error_on_empty && !$v.email.required">
                Field is required
              </div>
            </div>

            <div class="label">Phone<span style="color: red">*</span></div>
            <div class="phone-input">
              <div class="input-group-section">
                <div class="form-group" :class="{
                  'not-empty': phone.length,
                  'form-group--error': show_error_on_empty && $v.phone.$error,
                }">
                  <el-input v-model="phone" size="small" type="number" class="form-control" placeholder="Phone"
                    name="Phone" @input="setPhoneNo($event)">
                    <template slot="prepend">+91</template>
                  </el-input>
                </div>
                <div class="error-text" v-if="!isPhoneNoValid">
                  Please enter a valid phone number
                </div>
                <div class="error" v-if="show_error_on_empty && !$v.phone.required">
                  Field is required
                </div>
              </div>
            </div>

            <div class="label">Company<span style="color: red">*</span></div>
            <div class="input-group-section">
              <div class="form-group" :class="{
                'not-empty': company.length,
                'form-group--error': show_error_on_empty && $v.company.$error,
              }">
                <el-input v-model="company" size="small" type="text" class="form-control" placeholder="Company"
                  name="Company" @input="setCompany($event)"></el-input>
              </div>
              <div class="error" v-if="show_error_on_empty && !$v.company.required">
                Field is required
              </div>
            </div>

            <div class="checklist">
              <el-checkbox-group v-model="checkList">
                <el-checkbox label="StockAnts community"></el-checkbox>
                <el-checkbox label="Partner with StockAnts"></el-checkbox>
                <el-checkbox label="StockAnts Manager"></el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="text-center">
              <button class="send-btn" @click="bookDemoBroker()">
                BOOK NOW
              </button>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <Retailnavbar style="position: fixed; top: 0; width: 100%;"></Retailnavbar>
    <RetailFooter></RetailFooter>
  </div>
</template>

<script>
import { screenSize } from "../../mixins/ScreenSize.js";
import RetailFooter from "@/components/RetailSideCompo/RetailFooter.vue";
import Retailnavbar from "@/components/RetailSideCompo/RetailNavbar.vue";
import { serverAddr, serverHostName } from "../../networkConfig";
import { required } from "vuelidate/lib/validators";
import CripNotice from "crip-vue-notice";

export default {
  name: "brokerExpertPage",

  components: { RetailFooter, Retailnavbar },

  mixins: [screenSize],

  data() {
    return {
      isActive: true,
      checkList: [],
      options: [
        {
          value: "StockAnts community",
          label: "StockAnts community",
        },
        {
          value: "Partner with StockAnts",
          label: "Partner with StockAnts",
        },
        {
          value: "StockAnts Manager",
          label: "StockAnts Manager",
        },
      ],
      how_it_work_array: [
        {
          sr_no: "1",
          img: require("../../assets/images/ExpertLandingPage/Web/Advisors/Mask group-1.png"),
          title: "Sign Up",
        },
        {
          sr_no: "2",
          img: require("../../assets/images/ExpertLandingPage/Web/Advisors/Mask group-2.png"),
          title: "e KYC",
        },
        {
          sr_no: "3",
          img: require("../../assets/images/ExpertLandingPage/Web/Advisors/Mask group-3.png"),
          title: "Access to your Clients",
        },
        {
          sr_no: "4",
          img: require("../../assets/images/ExpertLandingPage/Web/Advisors/Mask group-4.png"),
          title: "Build your Track Record",
        },
        {
          sr_no: "5",
          img: require("../../assets/images/ExpertLandingPage/Web/Advisors/Mask group.png"),
          title: "Collects payments",
        },
      ],
      active_faq_type: "general",
      name: "",
      email: "",
      phone: "",
      company: "",
      show_error_on_empty: false,
      is_valid_email_error: false,
      isPhoneNoValid: true,
      isLoading: false,
      developerApiPdf:
        serverHostName + "/Media/important_doc/DeveloperAPISupport.pdf",
      TradingPartner:
        serverHostName + "/Media/important_doc/TradingPartner.pdf",
      MicrositeService:
        serverHostName + "/Media/important_doc/MicrositeService.pdf",
      ResearchPartner:
        serverHostName + "/Media/important_doc/ResearchPartner.pdf",
    };
  },
  watch: {
    email(newValue, oldValue) {
      let regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (newValue.trim()) {
        this.is_valid_email_error = false;

        if (regularExpression.test(newValue)) {
          this.is_valid_email_error = false;
        } else {
          this.is_valid_email_error = true;
          // this.is_valid_email_error = true;
        }
      } else {
        // this.is_valid_email_error = false;
      }
    },
  },
  validations: {
    name: {
      required,
    },
    email: {
      required,
    },
    phone: {
      required,
    },
    company: {
      required,
    },
  },

  methods: {
    setName(value) {
      this.name = value;
      this.$v.name.$touch();
    },
    setEmail(value) {
      this.email = value;
      this.$v.email.$touch();
    },
    setCompany(value) {
      this.company = value;
      this.$v.company.$touch();
    },
    setPhoneNo(value) {
      this.phone = value;
      this.$v.phone.$touch();
      this.isPhoneNoValid = true;
    },
    bookDemoBroker() {
      let purpose = this.checkList.toString();
      purpose = purpose.replace(/,/g, "|");

      this.show_error_on_empty = true;
      this.$v.$touch();
      if (
        this.name.trim() &&
        this.company.trim() &&
        this.email &&
        !this.is_valid_email_error &&
        this.phone.toString().length == 10
      ) {
        this.isLoading = true;
        serverAddr
          .post(`/base/v1/book_demo`, {
            source: "BRK",
            name: this.name,
            email: this.email,
            phone: this.phone,
            purpose: purpose,
            company: this.company,
          })
          .then((response) => {
            this.isLoading = false;
            if (response.data.status) {
              new CripNotice({
                title: "Success",
                description: response.data.validation,
                type: "success",
                duration: 3,
              });
            }
          })
          .catch((error) => {
            this.isLoading = false;
            console.log("error", error);
            new CripNotice({
              title: "Oops! Something went wrong!",
              description: "Please try again",
              type: "error",
              duration: 3,
            });
          });
      } else if (this.phone.toString().length != 10) {
        this.isPhoneNoValid = false;
      }
    },
  },
  mounted() {
    // set usertype for redirection
    localStorage.setItem("UserType", "BROKER");
  },
};
</script>
<style lang="scss" scoped>
.brokers-landing-page {
  overflow-x: hidden;
  margin-top: 60px;

  .top-banner {
    // height: 600px;
    background: #fdda0d;
    position: relative;
    padding-bottom: 80px;

    .section-tabs {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 50px;

      .label {
        font-size: 1.1rem;
        padding: 10px 50px;
        text-transform: uppercase;
        font-weight: 700;
        color: #ffff;
        border: 3px solid #ffff;
        text-decoration: none;
        cursor: pointer;
      }
    }

    .main-heading {
      // text-align: center;
      margin: 100px 0 50px;
      color: #15a3b6;
      text-transform: uppercase;
      font-size: 1.3rem;
    }

    .sub-section {
      padding-bottom: 50px;

      .img-section {
        width: 90%;
        margin: 0 auto;

        .top-txt {
          width: 70%;
          margin: 20px auto;
          font-size: 1.3rem;
          text-transform: uppercase;
          color: #ffff;
          font-weight: 700;
        }
      }

      .left-side {
        margin: 0 auto;

        .small-txt {
          font-size: 1.8rem;
          color: #7e7e7e;
          text-transform: uppercase;
        }

        .second-txt {
          font-size: 2.5rem;
          text-transform: uppercase;
          font-weight: 800;
          color: #ffff;
          margin: 5px 0 30px;
        }

        .para {
          font-size: 1rem;
          line-height: 1.4;
          margin-top: 40px;
        }

        .book-demo {
          margin-top: 50px;

          input[type="email"] {
            line-height: 26px;
            height: 26px;
            border-radius: 13px;
            border: 1px solid #c3c3c3;
            padding: 5px 20px;
            width: 90%;
          }

          input:focus {
            outline: none;
            border-color: #15a3b6;
          }

          a {
            border-radius: 10px;
            border: 1px solid #15a3b6;
            background-color: #15a3b6;
            padding: 15px 45px;
            font-size: 1.2rem;
            font-weight: 700;
            z-index: 1;
            cursor: pointer;
            margin-top: 25px;
            text-transform: uppercase;
            color: #ffff;
            text-decoration: none;
          }

          // button:hover {
          //   background-color: #faf443;
          //   color: gray;
          // }
        }
      }
    }
  }

  .card-section-desk {
    width: 100%;
    display: flex;
    justify-content: center;

    .top-cards {
      align-items: center;
      position: absolute;
      bottom: -80px;

      .cards {
        width: 250px;
        text-align: center;
        font-size: 1.3rem;
        text-transform: uppercase;
        font-weight: 700;
        margin: 15px;
        text-decoration: unset;
        cursor: pointer;
      }
    }
  }

  .card-section-mob {
    display: none;
  }

  .section2 {
    .community-top-section {
      text-align: center;
      margin: auto;
      // margin-top: 200px;
      width: 70%;

      h1 {
        text-transform: uppercase;
      }

      img {
        margin: 50px 0;
        width: 100%;
      }
    }

    .community-bottom-section {
      display: flex;
      justify-content: space-between;

      .bottom-inner {
        width: 400px;
      }

      .left {
        text-align: left;
        margin-right: auto;
      }

      .right {
        text-align: right;
        margin-left: auto;
      }

      .top-label {
        font-size: 0.8rem;
        text-transform: uppercase;
        color: #15a3b6;
        font-weight: 500;
        margin-bottom: 0px;
      }

      h2 {
        font-size: 1.4rem;
        text-transform: uppercase;
        font-weight: 700;
        margin: 0px;
      }

      .normal-txt {
        color: gray;
        font-weight: 500;
        margin: 40px 0 50px;
        height: 100px;
      }

      .blank-yellow {
        width: 230px;
        background: #fdda0d;
        height: 50px;
        border-radius: 10px;

        a {
          text-decoration: none;
          font-size: 1.2rem;
          font-weight: 500;
        }
      }
    }
  }

  .section3 {
    .community-top-section {
      text-align: center;
      margin: auto;

      // margin-top: 200px;
      p {
        margin: 0 auto;
        width: 80%;
      }

      h1 {
        text-transform: uppercase;
      }

      img {
        margin: 50px 0;
        width: 100%;
      }
    }

    .community-bottom-section {
      text-align: center;

      .bottom-inner {
        width: 100%;
      }

      .blank-yellow {
        width: 230px;
        background: #fdda0d;
        height: 50px;
        border-radius: 10px;
        margin: 0 auto;

        a {
          text-decoration: none;
          font-size: 1.2rem;
          font-weight: 500;
        }
      }
    }
  }

  .section4 {
    width: 650px;
    margin: 100px auto;
    // height: 1000px;
    margin-bottom: 40px;

    h1 {
      color: #000;
      font-size: 1.8rem;
      text-transform: uppercase;
      margin-bottom: 30px;
      text-align: center;
    }

    .checklist {
      margin-top: 40px;
    }

    .below-txt {
      margin-top: 0px;
      font-size: 0.9rem;
      font-weight: 500;
    }

    .label {
      text-transform: uppercase;
      color: #979797;
      font-size: 0.95rem;
      margin-bottom: 10px;
      margin-top: 30px;
    }

    .send-btn {
      font-size: 18px;
      font-weight: 800;
      padding: 10px 25px;
      border-radius: 10px;
      border: 1px solid #15a3b6;
      background-color: #15a3b6;
      color: #ffff;
      margin: 30px 0;
      width: 200px;
      cursor: pointer;
    }
  }

  .sec-5 {
    text-align: center;

    .tracking-outer {
      text-align: center;

      .head {
        font-size: 1.3rem;
        font-weight: 700;
        position: relative;
        top: 85px;
      }
    }

    .marquee {
      animation: marquee 20s linear infinite;
    }

    .marquee:hover {
      animation-play-state: paused;
    }

    @keyframes marquee {
      0% {
        transform: translate(0, 0);
      }

      100% {
        transform: translate(-100%, 0);
        // transform: translate(-2700px, 0);
      }
    }

    .marquee2 {
      animation: marquee2 15s linear infinite;
    }

    .marquee2:hover {
      animation-play-state: paused;
    }

    @keyframes marquee2 {
      0% {
        transform: translate(0, 0);
      }

      100% {
        transform: translate(-100%, 0);

        // transform: translate(-1900px, 0);
      }
    }


    #trading-container {
      display: flex;
      align-items: center;
      white-space: nowrap;
      height: 80px;
      position: relative;
      margin: 40px 0 10px;

      img {
        width: 150px;
        height: 45px;
        margin: 10px 30px;
      }
    }

    #tracking-container {
      display: flex;
      align-items: center;
      white-space: nowrap;
      height: 80px;
      position: relative;
      margin: 40px 0 10px;

      img {
        width: 200px;
        height: 60px;
        margin: 20px;
      }
    }


    // .inner {
    //   display: flex;
    //   justify-content: space-between;
    //   // flex-wrap: wrap;
    //   align-items: center;
    //   img {
    //     width: 230px;
    //     margin: auto;
    //   }
    // }
    .tracking-bar {
      display: flex;
      width: 100%;
      background: #aed7e5;
      padding: 20px;
      margin: 40px 0;
    }

    .treding-bar {
      display: flex;
      width: 100%;
      margin: 40px 0;
      background: #fdea75;
      padding: 20px;
    }
  }

  @media screen and (max-width: 991px) {
    .top-banner {
      .main-heading {
        text-align: center;
        font-size: 1.1rem;
      }

      .sub-section {
        .left-side {
          width: 70%;
          margin: auto;
        }
      }
    }

    .top-cards .cards {
      width: 200px;
      font-size: 1rem;
      margin: 10px;
    }

    .section3,
    .section2 {
      .community-top-section {
        width: 100%;

        h1 {
          font-size: 1.5rem;
        }
      }

      .community-bottom-section {
        h2 {
          font-size: 1.2rem;
        }

        .top-label {
          font-size: 0.7rem;
        }

        .normal-txt {
          font-size: 0.9rem;
        }

        .bottom-inner {
          margin: 0 10px;
          padding: 15px;
          border-radius: 10px;
          box-shadow: 0px 0px 10px -3px #b6b6b6;
        }

        .blank-yellow {
          width: auto;
        }
      }
    }

    .section3 {
      .bottom-inner {
        box-shadow: unset !important;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .top-banner {
      .section-tabs .label {
        padding: 10px 20px;
      }

      .sub-section {
        padding-bottom: 25px;

        .left-side {
          width: 80%;
          margin-bottom: 40px;

          .second-txt {
            font-size: 1.8rem;
          }

          .small-txt {
            font-size: 1.4rem;
          }

          .para {
            font-size: 1rem;
          }
        }
      }

      .sub-section .img-section {
        width: 90%;
      }
    }

    .section2 .community-bottom-section {
      flex-direction: column;

      .normal-txt {
        height: auto;
      }

      .bottom-inner {
        margin: 20px auto;
        width: auto;
      }
    }

    .top-cards {
      bottom: -40px;

      .cards {
        width: 150px;
        font-size: 0.9rem;
      }
    }

    .card-section-desk {
      display: none;
    }

    .card-section-mob {
      display: block;

      .menu {
        color: #918e8e;
        display: flex;
        justify-content: center;
        font-size: 1rem;
        font-weight: 600;

        .spcl-menu {
          text-align: center;
          margin: 25px 10px;
          text-decoration: unset;
          cursor: pointer;
        }
      }
    }

    .section4 {
      width: 90%;
    }
  }

  @media screen and (max-width: 568px) {
    .section2 .community-bottom-section h2 {
      font-size: 0.9rem;
    }
  }

  @media screen and (max-width: 450px) {}
}

.broker-content {
  transform: translate(-20%, 13%);
  overflow: hidden;
  font-family: "Lato", sans-serif;
  font-size: 2.5rem;
  line-height: 45px;
  color: #000;
  width: 400px;
  text-transform: uppercase;

  &__container {
    font-weight: 600;
    overflow: hidden;
    height: 45px;
    padding: 0 40px;

    &__text {
      display: inline;
      float: left;
      margin: 0;
    }

    &__list {
      margin-top: 0;
      // padding-left: 110px;
      text-align: left;
      list-style: none;

      -webkit-animation-name: change;
      -webkit-animation-duration: 10s;
      -webkit-animation-iteration-count: infinite;
      animation-name: change;
      animation-duration: 10s;
      animation-iteration-count: infinite;

      &__item {
        line-height: 45px;
        margin: 0;
      }
    }
  }
}

@keyframes change {

  0%,
  12.66%,
  100% {
    transform: translate3d(0, 0, 0);
  }

  33.32%,
  45.98% {
    transform: translate3d(0, -33.33%, 0);
  }

  49.98%,
  62.64% {
    transform: translate3d(0, -66.66%, 0);
  }

  83.3%,
  95.96% {
    transform: translate3d(0, -33.33%, 0);
  }
}

// @keyframes change {
//   0%,
//   12.66%,
//   100% {
//     transform: translate3d(0, 0, 0);
//   }
//   16.66%,
//   29.32% {
//     transform: translate3d(0, -25%, 0);
//   }
//   33.32%,
//   45.98% {
//     transform: translate3d(0, -50%, 0);
//   }
//   49.98%,
//   62.64% {
//     transform: translate3d(0, -75%, 0);
//   }
//   66.64%,
//   79.3% {
//     transform: translate3d(0, -50%, 0);
//   }
//   83.3%,
//   95.96% {
//     transform: translate3d(0, -25%, 0);
//   }
// }
</style>

<style lang="scss">
.brokers-landing-page {
  #stockantsCommunity {
    .card1 {
      margin-top: 100px;

      .el-card {
        background: #472878;
        border-radius: 10px;
      }

      .el-card__body {
        padding: 0;
        padding-top: 20px;
      }

      .card2 {
        .el-card {
          background: #ffff;
          border-radius: 10px;
        }

        .el-card__body {
          padding: 60px 20px;
        }
      }
    }
  }

  #partnerWithUs {
    .card1 {
      margin-top: 100px;

      .el-card {
        background: #15a3b6;
        border-radius: 10px;
      }

      .el-card__body {
        padding: 0;
        padding-top: 20px;
      }

      .card2 {
        .el-card {
          background: #ffff;
          border-radius: 10px;
        }

        .el-card__body {
          padding: 60px 20px;
        }
      }
    }
  }

  #stockantsManager {
    .card1 {
      margin-top: 100px;

      .el-card {
        background: #da8016;
        border-radius: 10px;
      }

      .el-card__body {
        padding: 0;
        padding-top: 20px;
      }

      .card2 {
        .el-card {
          background: #ffff;
          border-radius: 10px;
        }

        .el-card__body {
          padding: 60px 20px;
        }
      }
    }
  }

  .book-demo {
    .el-input__inner {
      border-radius: 10px;
    }

    .el-select {
      // display: unset;
      width: 90%;
    }
  }

  .top-cards {
    display: flex;
    justify-content: center;
    align-items: center;

    .cards {
      .el-card {
        background: #ffff;
        color: #15a3b6;
        padding: 20px 30px;
        border-radius: 10px;
      }
    }

    .blue:hover {
      .el-card {
        background: #15a3b6;
        color: #ffff;
      }
    }

    .orange {
      .el-card {
        color: #da8016;
      }
    }

    .orange:hover {
      .el-card {
        background: #da8016;
        color: #ffff;
      }
    }

    .purple {
      .el-card {
        color: #472878;
      }
    }

    .purple:hover {
      .el-card {
        background: #472878;
        color: #ffff;
      }
    }
  }

  @media screen and (max-width: 778px) {
    .top-cards .cards .el-card {
      padding: 5px;
    }

    .sec-5 .inner img {
      width: 150px;
    }
  }

  @media screen and (max-width: 450px) {

    #stockantsManager .card1 .card2 .el-card__body,
    #partnerWithUs .card1 .card2 .el-card__body,
    #stockantsCommunity .card1 .card2 .el-card__body {
      padding: 25px 0px;
    }
  }
}
</style>

<style lang="scss">
.brokers-landing-page {
  .section4 {
    .el-checkbox__label {
      font-size: 12px;
    }

    .el-card {
      border-radius: 20px;
      box-shadow: 0 2px 20px -5px #ffda6f;
      border: none;
      padding: 30px;
    }

    .el-input {
      // margin-bottom: 30px;
    }

    .el-input-group__prepend {
      background-color: #ffff;
    }

    .el-input-group__append,
    .el-input-group__prepend {
      border: 2px solid #e5e5e5;
      border-right: 0;
    }

    .el-textarea__inner,
    .el-input__inner {
      border: 2px solid #e5e5e5;
    }

    .phone-input {
      .el-input__inner {
        border-left: 0;
      }
    }

    @media screen and (max-width: 1244px) {
      // .el-card {
      //   padding-left: 35%;
      // }
    }

    @media screen and (max-width: 992px) {
      .el-card {
        padding: 10px 30px;
      }
    }

    @media screen and (max-width: 768px) {
      .el-card {
        padding: 10px;
      }
    }

    @media screen and (max-width: 400px) {
      .el-card {
        padding: 0px;
      }
    }
  }
}
</style>
